// src/pages/MetricasPage.jsx
import React from 'react';
import MetricasManagement from '../features/metricas/MetricasManagement';

const MetricasPage = () => {
  return <MetricasManagement />;
};

export default MetricasPage;